export const REQUEST_ALL_FEATURES = 'features/REQUEST_ALL_FEATURES';
export const SET_ALL_FEATURES = 'features/SET_ALL_FEATURES';
